import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { services as fallback } from "../mock";
import { getPublicServices } from "../api";
import { log } from "../lib/log";

const toCard = (s, i) => ({ id: s.slug, number: String(i + 1).padStart(2, "0"), title: s.title, description: s.tagline + (s.metier ? " — " + s.metier.split(/(?<=\.)\s/)[0] : ""), tags: (s.avantages || []).slice(0, 3), image: s.hero_image, link: s.external || `/services/${s.slug}` });

const Services = ({ onQuote }) => {
  const [items, setItems] = useState(fallback);
  useEffect(() => {
    getPublicServices().then((r) => { if (r.data.items?.length) setItems(r.data.items.map(toCard)); }).catch((e) => log.error("services:", e));
  }, []);
  const words = ["", "Une", "Deux", "Trois", "Quatre", "Cinq", "Six"][items.length] || items.length;

  return (
    <section id="services" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-4">Nos prestations</p>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-neutral-900 leading-tight max-w-2xl">
            {words} expertises. <span className="text-brand">Un seul interlocuteur.</span>
          </h2>
          <p className="text-neutral-600 max-w-md text-lg">Nettoyage, espaces verts et petits travaux : une gamme complète pour l'entretien de vos locaux et de leurs extérieurs.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="services-grid">
          {items.map((s) => (
            <div key={s.id} className="group bg-white border border-neutral-200 rounded-2xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col" data-testid={`service-card-${s.id}`}>
              <a href={s.link} className="relative overflow-hidden block">
                <img src={s.image} alt={s.title} className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute top-4 left-4 bg-white/95 backdrop-blur text-neutral-900 font-heading font-bold text-sm px-3 py-1.5 rounded-md">{s.number}</div>
              </a>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-heading font-bold text-xl text-neutral-900"><a href={s.link} className="hover:text-brand">{s.title}</a></h3>
                <p className="mt-3 text-neutral-600 leading-relaxed line-clamp-4">{s.description}</p>
                <div className="mt-4 flex flex-wrap gap-2">{s.tags.map((t) => <span key={t} className="text-xs font-medium text-neutral-600 bg-neutral-100 px-2.5 py-1 rounded-md">{t}</span>)}</div>
                <div className="mt-auto pt-6 flex items-center gap-5">
                  <a href={s.link} className="inline-flex items-center gap-1 text-neutral-900 hover:text-brand font-semibold text-sm" data-testid={`service-link-${s.id}`}>En savoir plus <ArrowRight size={15} /></a>
                  <button onClick={onQuote} className="text-brand font-semibold text-sm">Demander un devis</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
